import React from 'react';
import PropTypes from 'prop-types';
/* helpers */
import { httpRequest } from '../../utils/xml-request-helper';
import { setArrayToFormData } from '../../utils/info-helper';
/* components */
import EditableList from '../../components/editable-list/editable-list';
import FlipSwitch from '../../components/flip-switch/flip-switch';
import Input from '../../components/input/input';
import Select from '../../components/select/select';
import Validation from '../../components/validation/validation';
import ScrollArea from '../../components/scroll-area/scroll-area';
/* styles */
import './clients.scss';

class ClientsFormPage extends React.PureComponent {
    constructor(props) {
        super(props);
        const selectedGrantTypes = props.model.grantTypes.filter(grantType =>
            props.model.client.allowedGrantTypes
            && props.model.client.allowedGrantTypes.indexOf(grantType.name) !== -1);
        const selectedScopes = props.model.scopes.filter(scope =>
            props.model.client.scopes && props.model.client.scopes.indexOf(scope.name) !== -1);
        this.state = {
            client: { ...props.model.client },
            selectedGrantTypes,
            selectedScopes,
            error: null
        };
    }

    getChangeHandler = (prop) => (value) => {
        this.setState({
            client: {
                ...this.state.client,
                [prop]: value
            }
        });
    };

    handleScopesChange = (selectedScopes) => {
        this.setState({ selectedScopes });
    };

    handleGrantTypesChange = (selectedGrantTypes) => {
        this.setState({ selectedGrantTypes });
    };

    handleSubmit = (formElement, enableSubmit) => {
        const form = new FormData(formElement);
        setArrayToFormData(form, 'Scopes', this.props.model.scopes.map((scope) => ({
            ...scope,
            selected: this.state.selectedScopes.findIndex(ss => scope.id === ss.id) !== -1
        })));
        setArrayToFormData(form, 'GrantTypes', this.props.model.grantTypes.map((grantType) => ({
            ...grantType,
            selected: this.state.selectedGrantTypes.findIndex(gt => grantType.id === gt.id) !== -1
        })));
        httpRequest({
            method: 'POST',
            url: window.location.pathname,
            token: this.props.token,
            onSuccess: () => { window.location.href = '/clients'; },
            onError: (res) => {
                this.setState({ error: res });
                enableSubmit();
            },
            body: form
        });
    };

    renderFlipSwitchRow = (label, prop, name) => (
        <div className="form-row">
            <div className="flex-row flex-center">
                <div className="flex-grow">
                    <label className="label">{label}</label>
                </div>
                <div className="flex-shrink">
                    <FlipSwitch
                        name={name}
                        isActive={this.state.client[prop]}
                        onChange={this.getChangeHandler(prop)}
                        activeLabel="YES"
                        inactiveLabel="NO"
                    />
                </div>
            </div>
        </div>
    );

    render() {
        const { client, selectedGrantTypes, selectedScopes } = this.state;
        const { grantTypes, scopes } = this.props.model;
        const isEdit = !!this.props.model.client.clientId;
        return (
            <div className="sten-content sten-clients-edit-page">
                <div className="sten-content__header flex-row">
                    <div className="flex-shrink">
                        <a rel="prev" className="btn-link icon" href="/clients" title="Back to clients list">
                            <span className="icon icon-arrow-left" />
                        </a>
                    </div>
                    <div className="flex-grow">
                        <h1 className="sten-content__title text-uppercase">
                            {isEdit
                                ? `Edit client - ${this.props.model.client.name}`
                                : 'Create new client'}
                        </h1>
                    </div>
                </div>
                <ScrollArea className="sten-content__body">
                    <Validation.Form
                        method="post"
                        name={isEdit ? 'Edit' : 'Create'}
                        action={isEdit ? 'Edit' : 'Create'}
                        onSubmit={this.handleSubmit}
                    >
                        {this.state.error && (
                            <section className="sten-content__section">
                                <p className="text-danger">{this.state.error}</p>
                            </section>
                        )}
                        <section className="sten-content__section">
                            <div className="row row--fluid">
                                <div className="col-lg-4 col-sm-6 col-xs-12">
                                    <label className="label">Client ID</label>
                                    <Validation.Wrapper validations={{ required: true }}>
                                        <Input
                                            disabled={isEdit}
                                            name="Client.ClientId"
                                            type="text"
                                            placeholder="Enter Client ID"
                                            value={client.clientId}
                                            onChange={this.getChangeHandler('clientId')}
                                        />
                                    </Validation.Wrapper>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-8 col-xs-12">
                                    <label className="label">Name</label>
                                    <Validation.Wrapper validations={{ required: true }}>
                                        <Input
                                            name="Client.Name"
                                            type="text"
                                            placeholder="Enter Client Name"
                                            value={client.name}
                                            onChange={this.getChangeHandler('name')}
                                        />
                                    </Validation.Wrapper>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-10 col-xs-24">
                                    <label className="label">Client Secret</label>
                                    <div className="flex-row">
                                        <div className="flex-shrink">
                                            <FlipSwitch
                                                name="Client.RequireClientSecret"
                                                isActive={client.requireClientSecret}
                                                onChange={this.getChangeHandler('requireClientSecret')}
                                            />
                                        </div>
                                        <div className="flex-grow">
                                            <Validation.Wrapper
                                                validations={{ required: true }}
                                                validate={client.requireClientSecret}
                                            >
                                                <Input
                                                    disabled={!client.requireClientSecret}
                                                    name="Client.ClientSecret"
                                                    type="text"
                                                    placeholder="Enter Client Secret"
                                                    value={client.clientSecret}
                                                    onChange={this.getChangeHandler('clientSecret')}
                                                />
                                            </Validation.Wrapper>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="sten-content__section">
                            <div className="row row--fluid">
                                <div className="col-lg-6 col-md-9 col-xs-12">
                                    <label className="label">Access token lifetime in seconds</label>
                                    <Validation.Wrapper
                                        validations={{ required: true, numeric: { min: 60, integer: true } }}
                                    >
                                        <Input
                                            name="Client.AccessTokenLifetimeSeconds"
                                            type="text"
                                            placeholder="Enter access token lifetime"
                                            value={client.accessTokenLifetimeSeconds}
                                            onChange={this.getChangeHandler('accessTokenLifetimeSeconds')}
                                        />
                                    </Validation.Wrapper>
                                </div>
                                <div className="col-lg-6 col-md-9 col-xs-12">
                                    <label className="label">Refresh token lifetime in seconds</label>
                                    <Validation.Wrapper
                                        validations={{
                                            required: true,
                                            numeric: {
                                                min: parseInt(client.accessTokenLifetimeSeconds, 10) || 0,
                                                integer: true
                                            }
                                        }}
                                    >
                                        <Input
                                            name="Client.AbsoluteRefreshTokenLifetimeSeconds"
                                            type="text"
                                            placeholder="Enter refresh token lifetime"
                                            value={client.absoluteRefreshTokenLifetimeSeconds}
                                            onChange={this.getChangeHandler('absoluteRefreshTokenLifetimeSeconds')}
                                        />
                                    </Validation.Wrapper>
                                </div>
                            </div>
                        </section>
                        <section className="sten-content__section">
                            <div className="row">
                                <div className="col-lg-12 col-md-18 col-xs-24">
                                    {this.renderFlipSwitchRow(
                                        'Enable Local Login', 'enableLocalLogin', 'Client.EnableLocalLogin'
                                    )}
                                    {this.renderFlipSwitchRow(
                                        'Require Consent', 'requireConsent', 'Client.RequireConsent'
                                    )}
                                    {this.renderFlipSwitchRow(
                                        'Allow Offline Access', 'allowOfflineAccess', 'Client.AllowOfflineAccess'
                                    )}
                                    {this.renderFlipSwitchRow(
                                        'Reuse Refresh Token', 'reUseRefreshToken', 'Client.ReUseRefreshToken'
                                    )}
                                    {this.renderFlipSwitchRow(
                                        'Update Access Token Claims On Refresh',
                                        'updateAccessTokenClaimsOnRefresh',
                                        'Client.UpdateAccessTokenClaimsOnRefresh'
                                    )}
                                    {this.renderFlipSwitchRow('Allow PKCE', 'requirePkce', 'Client.RequirePkce')}
                                </div>
                            </div>
                        </section>
                        <section className="sten-content__section">
                            <div className="row">
                                <div className="col-lg-12 col-md-18 col-xs-24">
                                    <div className="sten-panel">
                                        <div className="sten-panel__header">
                                            <h4>Post Login Redirect URLs</h4>
                                        </div>
                                        <div className="sten-panel__body">
                                            <div className="sten-panel__section">
                                                <EditableList
                                                    name="Client.RedirectUris"
                                                    labelInline
                                                    addBtnLabel="Add new redirect URL"
                                                    onChange={this.getChangeHandler('redirectUris')}
                                                    value={client.redirectUris || []}
                                                    validations={{ required: true, url: true }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="sten-content__section">
                            <div className="row">
                                <div className="col-lg-12 col-md-18 col-xs-24">
                                    <div className="sten-panel">
                                        <div className="sten-panel__header">
                                            <h4>Post Logout Redirect URLs</h4>
                                        </div>
                                        <div className="sten-panel__body">
                                            <div className="sten-panel__section">
                                                <EditableList
                                                    name="Client.PostLogoutRedirectUris"
                                                    labelInline
                                                    addBtnLabel="Add new redirect URL"
                                                    onChange={this.getChangeHandler('postLogoutRedirectUris')}
                                                    value={client.postLogoutRedirectUris || []}
                                                    validations={{ required: true, url: true }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="sten-content__section">
                            <div className="row row--fluid">
                                <div className="col-lg-6 col-md-9 col-xs-12">
                                    <label className="label">Scopes</label>
                                    <Select
                                        multiple
                                        name="Client.Scopes"
                                        placeholder="Select scopes"
                                        value={selectedScopes}
                                        onChange={this.handleScopesChange}
                                        options={scopes}
                                        valueKey="id"
                                        labelKey="name"
                                    />
                                </div>
                                <div className="col-lg-6 col-md-9 col-xs-12">
                                    <label className="label">Grant types</label>
                                    <Select
                                        multiple
                                        name="Client.AllowedGrantTypes"
                                        placeholder="Select grant types"
                                        value={selectedGrantTypes}
                                        onChange={this.handleGrantTypesChange}
                                        options={grantTypes}
                                        valueKey="id"
                                        labelKey="name"
                                    />
                                </div>
                            </div>
                        </section>
                        <section className="sten-content__section">
                            <div className="row">
                                <div className="col-lg-6 col-md-9 col-xs-12">
                                    <a className="btn btn--secondary btn--sm col-24" href="/clients">
                                        Cancel
                                    </a>
                                </div>
                                <div className="col-lg-6 col-md-9 col-xs-12">
                                    <Validation.Button
                                        className="btn btn--primary btn--sm col-24"
                                        value={isEdit ? 'Save' : 'Create'}
                                    >
                                        {isEdit ? 'Save client' : 'Create client'}
                                    </Validation.Button>
                                </div>
                            </div>
                        </section>
                        <input name="__RequestVerificationToken" type="hidden" value={this.props.token} />
                    </Validation.Form>
                </ScrollArea>
            </div>
        );
    }
}

ClientsFormPage.propTypes = {
    model: PropTypes.objectOf(PropTypes.any).isRequired,
    token: PropTypes.string.isRequired
};

export default ClientsFormPage;
